export const ParagrafTemplate = ({ children, className }) => {
  return (
      <p className={
          `text-xs md:text-sm text-slate-custom leading-relaxed ${className}`
      }>{children}</p>
  )
}